import React from "react";
import Seo from "../components/Seo";
import { PageHero, CTABand } from "../components/Shared";
import { IMAGES, ACCREDITATION } from "../mock";
import { Target, HeartHandshake, Users, ShieldCheck, MapPin, Award } from "lucide-react";

const BASE = "https://carefirstoh.com";
const values = [
  { icon: HeartHandshake, title: "Our Mission", text: "To deliver compassionate, high-quality home health care that helps our clients live safely and independently at home." },
  { icon: Users, title: "Patient-Centered", text: "We build individualized care plans around each person's needs, preferences, and goals." },
  { icon: ShieldCheck, title: "Professional Standards", text: "As a CHAP-accredited agency, we hold ourselves to rigorous quality and safety standards." },
  { icon: MapPin, title: "Community Rooted", text: "We proudly serve Columbus and the surrounding Central Ohio communities we call home." },
];

const About = () => (
  <div>
    <Seo title="About CareFirst Home Health | Columbus, OH Home Health Agency" description="Learn about CareFirst Home Health Services, a CHAP-accredited home health agency in Columbus, Ohio committed to compassionate, patient-centered care." canonical={BASE + "/about"} />
    <PageHero title="About CareFirst Home Health" subtitle="Caring for you. Caring for your family. Compassionate home health care rooted in Columbus, Ohio." crumbs={[{ label: "Home", to: "/" }, { label: "About Us" }]} />

    <section className="bg-white py-20">
      <div className="max-w-[1150px] mx-auto px-4 grid lg:grid-cols-2 gap-14 items-center">
        <div className="rounded-3xl overflow-hidden shadow-2xl h-[420px]"><img src={IMAGES.eligibility} alt="CareFirst caregiver supporting seniors at home in Columbus, Ohio" className="w-full h-full object-cover" /></div>
        <div>
          <h2 className="font-display text-[#16357a] text-[34px] md:text-[42px] font-semibold leading-tight mb-5">Compassion. Care. Always.</h2>
          <p className="text-[#4a4a4a] text-[16px] leading-relaxed mb-4">CareFirst Home Health Services LLC is a certified, CHAP-accredited home health agency proudly serving Columbus and Central Ohio. We help seniors and adults with disabilities receive the care they need in the place they love most — home.</p>
          <p className="text-[#4a4a4a] text-[16px] leading-relaxed mb-4">Our team of dedicated caregivers and licensed clinicians works closely with patients, families, physicians, and case managers to deliver coordinated, reliable care. From skilled nursing to everyday personal support, we treat every client like family.</p>
          <p className="text-[#4a4a4a] text-[16px] leading-relaxed">We accept Medicare, Medicaid, PASSPORT, DODD, VA, and major Ohio managed-care plans, making quality home health care accessible to more families across our community.</p>
        </div>
      </div>
    </section>

    <section className="bg-[#eef6ea] py-20">
      <div className="max-w-[1240px] mx-auto px-4">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.title} className="bg-white rounded-2xl p-7 shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 rounded-full bg-[#eef6ea] flex items-center justify-center mb-4"><v.icon size={26} className="text-[#4ca82f]" /></div>
              <h3 className="font-display text-[#16357a] text-[20px] font-semibold mb-2">{v.title}</h3>
              <p className="text-[#666] text-[14px] leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="bg-white py-20">
      <div className="max-w-[1000px] mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
        <div className="flex justify-center"><img src={ACCREDITATION.seal} alt="CHAP Seal of Accreditation - Home Health" className="max-w-[360px] w-full" /></div>
        <div>
          <div className="inline-flex items-center gap-2 text-[#4ca82f] font-bold mb-3"><Award size={20} /> Accredited & Committed to Excellence</div>
          <h2 className="font-display text-[#16357a] text-[30px] md:text-[38px] font-semibold leading-tight mb-4">{ACCREDITATION.heading}</h2>
          <p className="text-[#4a4a4a] text-[16px] leading-relaxed">{ACCREDITATION.body}</p>
        </div>
      </div>
    </section>

    <CTABand />
  </div>
);

export default About;
